export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const API = {
  BASE_URL: `${API_BASE_URL}/api`,
  BUSINESS_REGISTER: `${API_BASE_URL}/business-main/register`,
  BUSINESS_CATEGORIES: `${API_BASE_URL}/business-main/categories`,
  COUNTRIES: `${API_BASE_URL}/business-main/countries`,
  STATES: `${API_BASE_URL}/business-main/states`,
};
